module.exports = ".box-product{\r\n    width: 100%;\r\n}\r\n/* .product-item{\r\n    width: 33%;\r\n} */\r\n/* .product-thumb{\r\n    width: 100%;\r\n} */\r\n/* .main-img,\r\n.overlay-img{\r\n    width: 80%;\r\n    \r\n} */\r\n/* img{\r\n    \r\n    width:100%\r\n} */\r\n.group-buttons{\r\n    text-align: center !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/brand-features/brand-features.component.css
// module id = ./src/app/components/brand-features/brand-features.component.css
// module chunks = main